import Stars from "@mui/icons-material/Stars";
import { Chip, Stack, Tooltip } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { ConditionalWrapper } from "../generic/components/conditional-wrapper";

export const CustomTemplateChip: FC<{ designer?: string | null }> = ({ designer }) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      sx={{
        position: "absolute",
        top: 8,
        right: 8,
        justifyContent: "flex-end",
        width: "100%",
        color: "#C87500",
      }}
    >
      <ConditionalWrapper
        condition={!!designer}
        wrapper={(children) => (
          <Tooltip
            title={t("Created for you by {{designer}}", { designer })}
            placement="bottom"
            arrow
          >
            {children}
          </Tooltip>
        )}
      >
        <Chip
          size="small"
          icon={<Stars color="inherit" sx={{ fontSize: 16, width: 16, height: 16 }} />}
          label={t("Custom")}
          data-testid={"custom-template-chip"}
          sx={{
            background: "linear-gradient(180deg, #F4822B -10.42%, #FFF39A 100%)",
            color: "inherit",
            fontWeight: 700,
            textTransform: "uppercase",
          }}
        />
      </ConditionalWrapper>
    </Stack>
  );
};
